import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { EcoTimeoutError } from '@app/eco-timeout-error'
import { Observable, TimeoutError, throwError, timer } from 'rxjs'
import { catchError, delayWhen, retryWhen, take, timeout } from 'rxjs/operators'

const initialDelay = 500

@Injectable()
export class TimeoutInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> | any {
    return next.handle(request).pipe(
      timeout(5000),
      // https://stackoverflow.com/questions/41872700/how-do-i-adjust-timeout-duration-on-retry-using-rxjs
      retryWhen((errors: any) =>
        errors.pipe(
          delayWhen((e: any, i: number) => {
            // TimeoutError가 아니라면 바로 다시 throw
            if (e.name !== 'TimeoutError') return throwError(e)
            // const delay = (i+1)*initialDelay;           // geometric
            // const delay = Math.pow(2, i) * initialDelay // exponential
            const delay = initialDelay // exponential
            // console.log(`retrying after ${delay} msec...`)
            return timer(delay)
          }),
          take(3),
        ),
      ),
      catchError((e: any) => {
        // custom한 EcoTimeoutError를 만들고 이를 global-error-handler에서 처리
        if (e instanceof TimeoutError) return throwError(new EcoTimeoutError())
        return throwError(e)
      }),
    )
  }
}
